import { render, staticRenderFns } from "./DUDDocuments.vue?vue&type=template&id=64c82ab8&scoped=true&"
import script from "./DUDDocuments.vue?vue&type=script&lang=ts&"
export * from "./DUDDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./DUDDocuments.vue?vue&type=style&index=0&id=64c82ab8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c82ab8",
  null
  
)

export default component.exports